/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CA
 */
export interface CA {
    /**
     * 
     * @type {boolean}
     * @memberof CA
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CA
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CA
     */
    thumbPrint?: string;
}

export function CAFromJSON(json: any): CA {
    return CAFromJSONTyped(json, false);
}

export function CAFromJSONTyped(json: any, ignoreDiscriminator: boolean): CA {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': !exists(json, 'active') ? undefined : json['active'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'thumbPrint': !exists(json, 'thumbPrint') ? undefined : json['thumbPrint'],
    };
}

export function CAToJSON(value?: CA | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
        'name': value.name,
        'thumbPrint': value.thumbPrint,
    };
}

